export const SSID_KEY = "USER_SSID_SESSION_STORAGE-.#5/~%`";